import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function RemoveDialog(props) {
  const { open, setOpen, onApprove, onCancel } = props

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      // slotProps={{ container: { backgroundColor: 'red' } }}
    >
      <DialogTitle id="alert-dialog-title">
        Do you really want to remove this config?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Any clients that configured to use this config will not be able to connect to your server.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} autoFocus>Cancel</Button>
        <Button onClick={onApprove}>
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}